import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { PriceParam } from '../models/price-param.model';
import { Page } from '../models/page.model';
import { PriceParamCliente } from '../models/price-param-cliente';
import { PriceParamParceiro } from '../models/price-param-parceiro';

@Injectable({
    providedIn: 'root'
})
export class PriceParamService extends BaseService<PriceParam>  {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/PriceParam`, injector);
    }

    getParamById(id: number): Observable<PriceParam> {
        return this.http.get<PriceParam>(`${environment.API_PRICE}/PriceParam/GetById/${id}`);
    }

    getByTipo(tipo: string): Observable<Page<PriceParam>> {
        return this.http.get<Page<PriceParam>>(`${environment.API_PRICE}/PriceParam/GetByTipo/${tipo}`);
    }

    updateAll(params: PriceParam[]) {
        return this.http.put(`${environment.API_PRICE}/PriceParam/updateAll`, params);
    }

    getByClienteId(clienteId: number): Observable<Page<PriceParamCliente>> {
        return this.http.get<Page<PriceParamCliente>>(`${environment.API_PRICE}/priceparam/get-parametro-cliente/${clienteId}`)
    }

    getByParceiroId(parceiroId: number): Observable<Page<PriceParamParceiro>> {
        return this.http.get<Page<PriceParamParceiro>>(`${environment.API_PRICE}/priceparam/get-parametro-cliente/${parceiroId}`)
    }

    gravarParametrosCliente(paramsCliente: PriceParamCliente[]) {
        return this.http.post(`${environment.API_PRICE}/priceparam/gravar-parametro-cliente`, paramsCliente)
    }

    gravarParametrosParceiro(paramsParceiro: PriceParamParceiro[]) {
        return this.http.post(`${environment.API_PRICE}/priceparam/gravar-parametro-cliente`, paramsParceiro)
    }
}
